export default __webpack_public_path__ + "assets/a9e11586578bd9a85a43227ae65dd7a4.png";